// This interface defines the parameters required to fetch working days from the API
// monthYear should be in the format 'YYYY-MM' and uuid is a unique identifier for the request
// The API will return the number of working days for the specified month and year
export interface WorkingDaysApiParams {
    monthYear: string; // Format: 'YYYY-MM'
    uuid: string;
}
// This interface defines the structure of the API response for working days
export interface WorkingDaysApiResponse {
    workingDays: number;
    working_days: number; // Alias for workingDays
}

// This function fetches the number of working days for a given month and year from the database
// It constructs a SQL query to count the working days for the specified month and year
// The monthYear parameter should be in the format 'YYYY-MM' and uuid is a unique identifier for the request
// It returns a promise that resolves to an array of WorkingDaysApiResponse objects
export async function getWorkingDaysFromDB(params: WorkingDaysApiParams): Promise<WorkingDaysApiResponse[]> {
    const [year, month] = params.monthYear.split("-");
    let _q = `
        SELECT *
        FROM working_days
        WHERE 1=1
    `;

    if (params.uuid && params.monthYear) {
        _q += `
            AND uuid = '${params.uuid}'
            AND LEFT(month_year, 4) = '${year}'
            AND RIGHT(month_year, 2) = '${month.padStart(2, "0")}'
        `;
    }

    console.log("Query to fetch working days:", _q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["working_days"],
            }),
        });

        let data = await response.json();
        // console.log(data);

        return data;
    } catch (error) {
        console.log("Error fetching working days:", error);
        return [];
    }
}
